var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('super-member',{attrs:{"activeCode":'cardMall',"env":_vm.env,"jumpType":2,"bizType":"ride","btnBgColor":'red'}}),_c('div',{on:{"click":_vm.cesshi}},[_vm._v("测试")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }